<template>
  <v-container fluid pt-0>
    <v-row align="center" class="pb-2">
      <h1 class="headline">Task Statuses</h1>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" fab dark color="primary" @click="onCreateNew">
            <v-icon dark>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Create New Task Status</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col class="pa-0">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="$apollo.loading"
          item-key="id"
          v-bind="pagingOptions"
          mobile-break-point="1264"
          class="elevation-1"
        >
          <template v-slot:item.actions="{ item }">
            <default-list-actions
              :item="item"
              hideView
              @editItem="onEditItem"
              @deleteItem="onDeleteItem"
            ></default-list-actions>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <task-status-edit-dialog
      v-model="editedItem"
      :show="showItemEditor"
      @close="showItemEditor = false"
      @input="onSave"
    />
    <v-row v-if="debug">
      <v-col>
        <code>{{ itineraryTaskStatuses }}</code>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import gql from "graphql-tag";
import TaskStatusEditDialog from "./TaskStatusEditDialog";
import DefaultListActions from "../../shared/DefaultListActions.vue";
import { ListMixin } from "../../../../mixins/ListMixin";
import { removeGQLTypename } from "../../../../helpers";
const LIST_QUERY = gql`
  query allItineraryTaskStatuses {
    itineraryTaskStatuses {
      edges {
        node {
          id
          name
          isDefault
        }
      }
    }
  }
`;
const CREATE_MUTATION = gql`
  mutation createItineraryTaskStatus($input: ItineraryTaskStatusInput!) {
    createItineraryTaskStatus(input: $input) {
      id
      name
    }
  }
`;
const UPDATE_MUTATION = gql`
  mutation updateItineraryTaskStatus($input: ItineraryTaskStatusInput!) {
    updateItineraryTaskStatus(input: $input) {
      id
      name
    }
  }
`;
const DELETE_MUTATION = gql`
  mutation deleteItineraryTaskStatus($id: ID!) {
    deleteItineraryTaskStatus(id: $id) {
      id
    }
  }
`;
export default {
  name: "task-status-list",

  mixins: [ListMixin],

  components: {
    TaskStatusEditDialog,
    DefaultListActions,
  },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
          align: "center",
        },
      ],
      showItemEditor: false,
      editedItem: null,
    };
  },

  computed: {
    items() {
      return this.itineraryTaskStatuses && this.itineraryTaskStatuses.edges
        ? this.itineraryTaskStatuses.edges.map(removeGQLTypename)
        : [];
    },
  },

  methods: {
    onCreateNew() {
      this.editedItem = null;
      this.showItemEditor = true;
    },
    async onSave(payload) {
      this.showItemEditor = false;
      const mutation = payload.id ? UPDATE_MUTATION : CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: { input: { ...payload } },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Task Status Saved.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onDeleteItem(payload) {
      this.$apollo
        .mutate({
          mutation: DELETE_MUTATION,
          variables: {
            id: payload.id,
          },
          refetchQueries: [
            {
              query: LIST_QUERY,
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Task Status Removed.",
          });
        })
        .catch((err) => {
          const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
          this.$store.dispatch("showAppSnackbar", {
            msg: errorMsg,
            color: "error",
          });
        });
    },
    onEditItem(payload) {
      this.editedItem = { ...payload };
      this.showItemEditor = true;
    },
  },

  apollo: {
    itineraryTaskStatuses: {
      query: LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/tasks/TaskStatusList.vue